export default __webpack_public_path__ + "static/media/applications-image-26.e1e28ee4.jpg";